/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import COLOR_LABELS from 'cio/utils/color-labels';

interface TemplateWithLabelArgs {
  name: string;
  index: number;
  labelClassNames?: string;
}

export default class TemplateWithLabel extends Component<TemplateWithLabelArgs> {
  get label() {
    return COLOR_LABELS[this.args.index];
  }
}
